import type { FaireProductEntity } from "../../entity_types/product";

export const p_j74pqsjyps: FaireProductEntity = {
  token: "p_j74pqsjyps",
  type: "product",
  name: "Scenic Route Candle",
  brandToken: "b_jx5r7yrney",
  brandName: "Loam Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/c33c98b4c3047bf3c18940654565f4a5a08de2f523f58914da7fa2d89f48b92d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cea08305e47a23c69fc6e0f9f4739c06cd12bcd3853ca7d519f284b245883b3.jpeg",
    "https://cdn.faire.com/fastly/21a4ae4a5be026dc9f7e386c99a6bf1e4033a2cfa707c634b80a959617b28181.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "Scent Vibe: uplifting, spicy, fresh, earthy\n\nWide open spaces, winding roads, towering trees, full lungs, grasses swaying in the wind. Lush cedar and vetiver, spicy gingergrass, and hints of citrusy bergamot combine to create both a grounding and invigorating blissfully ozonic scent.\n\nScent Notes: cedarwood, vetiver, gingergrass, bergamot\n\nEvery candle is crafted in small batches with coconut soy wax and 100% cotton wicks. Loam candles are always paraben, paraffin, petroleum, and phthalate-free.\n\nSize: 7.4oz/210g\n\nBurn time: 40-50 hours",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:02.849Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
